import React from 'react';
import Section from '../Team/Section';
import TeamPage from '../Team/TeamPage';
import MetaTags from '../../../helpers/Common/MetaTags';
import { getMetaConfig } from '../../../helpers/Common/metaConfig';

const Team = () => {
    const teamMeta = getMetaConfig('team');
    
    return (
        <React.Fragment>
            <MetaTags {...teamMeta} />
            <Section/>
            <TeamPage/>
        </React.Fragment>
    )
}

export default Team;
